import React from 'react';
import SectionHeader from '../components/ui/SectionHeader';
import CopyBlock from '../components/ui/CopyBlock';

export default function Scripts() {
  return (
    <section>
      <SectionHeader id="scripts" title="9-10. Scripts & Objection Handling" subtitle="Copy-paste templates and battlecards." />
      
      <div className="space-y-8">
        
        <div>
          <h3 className="text-xl font-bold text-white mb-4">Outreach Templates</h3>
          <CopyBlock 
            title="Cold Email: Content Focus (The Pitch Feed)" 
            text={`Subject: Scaling [Company]'s football coverage
            
Hi [Name],

Noticed you guys are covering the Premier League heavily, but missing out on the long-tail traffic from the Championship and European leagues. 

Building an editorial team for that is expensive. We provide automated, publish-ready football content (previews, recaps, news) that plugs right into your CMS. 

Our clients use it to double their output without adding headcount. 

Open to a brief look at how the feed works next week?

Best,
[Your Name]`} 
          />
          
          <CopyBlock 
            title="Cold Email: Engagement Focus (ScoreWidget)" 
            text={`Subject: Live data on [Company] articles
            
Hi [Name],

Read your recent piece on [Topic]. Great insight. 

I'm reaching out because publishers are losing match-day traffic to live-score apps. We provide drop-in widgets (live scores, standings, line-ups) that you can embed directly into your articles with zero dev work.

It turns a static article into a live match center, keeping users on your site longer (and viewing more ads).

Worth 5 minutes to see a mock-up of how it looks on your site?

Best,
[Your Name]`} 
          />
        </div>

        <div>
          <h3 className="text-xl font-bold text-white mb-4 mt-8">Objection Handling</h3>
          
          <div className="space-y-4">
            <div className="bg-slate-800 p-5 rounded-lg border border-slate-700">
              <h4 className="text-lg font-bold text-white mb-2">"We already create content in-house."</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm mt-3">
                <div>
                  <span className="text-red-400 font-bold block mb-1">Weak Answer:</span>
                  <p className="text-slate-400">"Our content is better/cheaper." (Subjective, causes arguments).</p>
                </div>
                <div>
                  <span className="text-emerald-400 font-bold block mb-1">Best Answer (Pivot to Value):</span>
                  <p className="text-slate-300">"That's exactly why we should talk. Your in-house team should be writing high-value opinion and analysis, not grinding out routine match previews and stats. We automate the routine stuff so your expensive talent can focus on what actually differentiates your brand."</p>
                </div>
              </div>
            </div>

            <div className="bg-slate-800 p-5 rounded-lg border border-slate-700">
              <h4 className="text-lg font-bold text-white mb-2">"We already use a data provider (Opta/Sportradar)."</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm mt-3">
                <div>
                  <span className="text-red-400 font-bold block mb-1">Weak Answer:</span>
                  <p className="text-slate-400">"We are cheaper than them." (Commoditizes the product).</p>
                </div>
                <div>
                  <span className="text-emerald-400 font-bold block mb-1">Best Answer (Pivot to UI):</span>
                  <p className="text-slate-300">"Having the raw data API is great, but building and maintaining the front-end UI for it takes dev resources. ScoreWidget is the presentation layer. We give you beautiful, responsive widgets you can drop in today, bypassing your dev backlog entirely."</p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}